<template>
  <div>
    <b-button 
      variant="primary" 
      @click="showModal"
      :disabled="sent"
    >
      {{buttonText}}
    </b-button>
    <b-modal
      ref="survey-invite-modal" 
      title="Invite users"
      :ok-disabled="sending || sent"
      @ok.prevent="sendSurvey"
    >
      <SelectUsersList
        :users="modifiedUsers"
      ></SelectUsersList>

      <template v-slot:modal-ok >
        <div style="width: 160px">
          <b-spinner v-if="sending" small label="Spinning" />
          <span v-else>Send</span>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import SelectUsersList from "@/sub-components/SelectUsersList.vue";

export default {
  name: "FacilitatorSurveyButton",
  props:{
    survey: { type: Object, default: null },
    meetingId: { type: String, default: '' },
    users: { type: Array, default: () => [] },
    attendees: { type: Array, default: () => [] }
  },
  components: {
    SelectUsersList
  },
  data() {
    return {
      sending: false,
      sent: false,
    }
  },
  methods: {
    showModal() {
      this.modifiedUsers.forEach(u => {
        u.selected = u.selected || this.attendees.some(a => a.userId == u.userId);
      });
      this.$nextTick(() => {
        this.$refs["survey-invite-modal"].show();
      });
    },
    hideModal() {
      this.$refs["survey-invite-modal"].hide();
    },
    sendSurvey(){
      this.sending = true;
      let request = [
        ...this.modifiedUsers.filter(u => u.selected).map(u => u.userId)
      ];

      axios
        .post(`${this.$api_url}/meetings/${this.meetingId}/send-facilitator-survey`, request, this.getReqConfig())
        .then(() => {
          this.sent = true;
          this.hideModal();
        })
        .catch((err) => {
          this.$emit('error', err);
        })
        .finally(() => {
          this.sending = false;
        });
    }
  },
  computed: {
    buttonText(){
      if (this.sent) {
        return "Sent!";
      }

      return this.survey == null ? "Send Session Evaluation" : "Resend Session Evaluation";
    },
    modifiedUsers() {
      return this.users.map(u => ({
        ...u,
        selected: false
      }));
    }
  }

}
</script>

